/* WhyGolf app "What's inside" feature carousel — click driven, no autoplay.

   Ported from the Replo page's inline script. Changed from the original: the
   root is `this` rather than document.currentScript.previousElementSibling,
   which was fragile and broke whenever the theme editor re-rendered the
   section. Keyboard support comes free from using real <button> elements. */

class AppFeatureCarousel extends HTMLElement {
  connectedCallback() {
    this.images = Array.from(this.querySelectorAll('.app-fcar__frame img'));
    this.cards = Array.from(this.querySelectorAll('.app-fcar__card'));
    this.dots = Array.from(this.querySelectorAll('.app-fcar__dot'));
    if (!this.images.length) return;

    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const trigger = event.target.closest('.app-fcar__card, .app-fcar__dot');
    if (!trigger || !this.contains(trigger)) return;

    const list = trigger.classList.contains('app-fcar__dot') ? this.dots : this.cards;
    const index = list.indexOf(trigger);
    if (index !== -1) this.go(index);
  };

  go(index) {
    this.images.forEach((el, i) => el.classList.toggle('is-active', i === index));
    this.dots.forEach((el, i) => {
      el.classList.toggle('is-active', i === index);
      el.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
    this.cards.forEach((el, i) => {
      el.classList.toggle('is-active', i === index);
      el.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
  }
}

if (!customElements.get('app-feature-carousel')) {
  customElements.define('app-feature-carousel', AppFeatureCarousel);
}
